const common = {
  siteName: '秘密教学漫画',
  siteDescription: '最全合集与深度解析',
  home: '首页',
  latestChapters: '最新章节',
  plotAnalysis: '剧情解析',
  characterIntro: '角色介绍',
  reviews: '深度评测',
  collections: '合集推荐',
  about: '关于我们',
  backToTop: '回到顶部',
  readMore: '阅读更多',
  viewAll: '查看全部',
  relatedArticles: '相关推荐',
  noContent: '暂无内容',
  notFound: '未找到',
};

export default common;